import {createFileRoute} from '@tanstack/react-router';

import {TeamPage} from '@/features/team';

export const Route = createFileRoute('/_app/team/')({
  beforeLoad: () => ({
    getTitle: () => 'Команда',
  }),
  component: () => <TeamPage />,
});
